
import { defineComponent } from 'vue'

// presentation information
interface PresentationInfo {
  title: string,
  location: string,
  date: string,
  note?: string
}

export default defineComponent({
  data () {
    return {
      presentations: [
        {
          title: '超伝導体の励起構造の分類とトポロジー',
          location: 'Komaba Bussei Seminar, The University of Tokyo',
          date: 'January 2023'
        },
        {
          title: 'Theoretical argument of superconducting gap classification & topological SNS junction',
          location: 'Prof. Yukio Tanaka\'s group, Nagoya University (via Zoom)',
          date: 'October 2021'
        },
        {
          title: 'Modern classification theory of superconducting gap nodes',
          location: 'Condensed Matter Seminar, University of California, Davis (via Zoom)',
          date: 'January 2021'
        },
        {
          title: 'トポロジカル結晶ノーダル超伝導の分類理論',
          location: 'Prof. Akira Furusaki\'s group, RIKEN',
          date: 'November 2019'
        },
        {
          title: 'Topological Gapless Points in Superconductors: from the viewpoint of symmetry',
          location: 'Physics Colloquium, University of Wisconsin-Milwaukee',
          date: 'March 2019'
        },
        {
          title: '高対称線上の超伝導ノードのトポロジカル的分類',
          location: 'Prof. Haruki Watanabe\'s group, The University of Tokyo',
          date: 'February 2019'
        },
        {
          title: '高対称軸上におけるトポロジカル結晶超伝導ノードの分類：点ノード，線ノード，面ノード',
          location: 'Prof. Hiroshi Kontani\'s group, Nagoya University',
          date: 'December 2018'
        },
        {
          title: 'Classification of topological crystalline superconducting nodes on high-symmetry axis',
          location: 'Prof. Yasuhiro Hatsugai\'s group, University of Tsukuba',
          date: 'November 2018'
        },
        {
          title: 'Classification of unconventional symmetry-protected superconducting gap structure',
          location: 'Prof. Manfred Sigrist\'s group, ETH Zürich',
          date: 'June 2018'
        }
      ] as PresentationInfo[]
    }
  }
})
